import React from 'react';

import Icon from '../Icon/Icon';

const BatteryIcon = (props) => {
    const {percentage, fill, stroke, ...rest} = props;

    return (
        <Icon width='24' height='24' fill='none' {...rest}>
            <defs>
                <linearGradient id='gradient' x1='0%' y1='0%' x2='100%' y2='0%'>
                    <stop offset='0%' stopColor={fill} />
                    <stop offset={`${percentage}%`} stopColor={fill} />
                    <stop offset={`${percentage}%`} stopOpacity={0} />
                    <stop offset='100%' stopOpacity={0} />
                </linearGradient>
            </defs>
            <path
                fill='url("#gradient")'
                fillRule='evenodd'
                clipRule='evenodd'
                d='M6.213 9.867h8.708c.192 0 .377.08.513.223a.782.782 0 0 1 .212.539v2.742a.781.781 0 0 1-.212.54.708.708 0 0 1-.513.222H6.213a.709.709 0 0 1-.513-.223.781.781 0 0 1-.212-.539V10.63c0-.202.076-.396.212-.54a.709.709 0 0 1 .513-.222z'
            />
            <path
                clipRule='evenodd'
                d='M15.791 8c.451 0 .86.192 1.155.502.295.31.478.74.478 1.212v4.572c0 .473-.183.902-.478 1.212A1.59 1.59 0 0 1 15.79 16H5.633a1.56 1.56 0 0 1-.625-.13 1.624 1.624 0 0 1-.53-.372 1.717 1.717 0 0 1-.354-.556A1.783 1.783 0 0 1 4 14.286V9.714c0-.473.183-.902.478-1.212A1.59 1.59 0 0 1 5.633 8H15.79z'
                stroke={stroke}
                strokeWidth='1.5'
            />
            <path d='M20 9.334v5.333' stroke={stroke} strokeWidth='1.5' strokeLinecap='round' />
        </Icon>
    );
};

export default BatteryIcon;
